export function validateString (rule, value, callback) {
  if (value && !/^[a-zA-Z]+$/.test(value)) {
    callback(new Error("* Invalid input"))
  } else {
    callback()
  }
}

export function validateSpaceString (rule, value, callback) {
  if (value && !/^[a-zA-Z\s]+$/.test(value)) {
    callback(new Error("* Invalid input"))
  } else {
    callback()
  }
}

export function validateSpaceStringNumeric (rule, value, callback) {
  if (value && !/^[a-zA-Z0-9\s]+$/.test(value)) {
    callback(new Error("* Invalid input"))
  } else {
    callback()
  }
}

export function validateNumber (rule, value, callback) {
  let number = parseInt(value, 10)
  
  if (!Number.isInteger(number)) {
    callback(new Error("* Enter a valid number"))
  } else {
    callback()
  }
}

export function validateEmail (rule, value, callback) {
  if (value && !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)) {
    callback(new Error("* Invalid Email"))
  } else {
    callback()
  }
}

export function validatePhoneNumber (rule, value, callback) {
  let phone_number_parts = value.split('-')

  if (phone_number_parts.length === 2 &&
      (phone_number_parts[0].length && Number.isInteger(+phone_number_parts[0])) &&
      (phone_number_parts[1].length && Number.isInteger(+phone_number_parts[1]))) {
    callback()
  } else {
    callback(new Error("* Invalid Fomat. Required: <country code>-<phone number>"))
  }
}

export function validateDate (rule, value, callback) {
  let now = +new Date(new Date())
  if (+value > now) {
    callback(new Error("* Select a valid date"))
  } else {
    callback()
  }
}

export function validateAddress (rule, value, callback) {
  if (value && !/^[a-zA-Z0-9\s,-]+$/.test(value)) {
    callback(new Error("* Invalid input"))
  } else {
    callback()
  }
}


// WEBPACK FOOTER //
// ./src/views/validations.js